<template>

  <div class="ace-paper-cont clear-mrg">

    <!-- START: PAGE CONTENT -->
    <header class="page-header padd-box">
      <h1 class="title-lg text-upper">Blog</h1>
    </header>

    <article class="post hentry">
      <div class="post-media">
        <a href="single-image.html" rel="bookmark">
          <figure class="post-figure">
            <img src="/static/img/uploads/post-image.jpg" alt="">
          </figure>
        </a>
      </div>

      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a rel="bookmark" href="single-image.html">Post With Image</a>
          </h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single-image.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <article class="post hentry">
      <div class="post-media">
        <div class="post-slider slider">
          <div>
            <a href="single-slider.html" rel="bookmark">
              <img src="/static/img/uploads/blog-slider-img.png" alt="">
            </a>
          </div>
          <div>
            <a href="single-slider.html" rel="bookmark">
              <img src="/static/img/uploads/blog-slider-img.png" alt="">
            </a>
          </div>
          <div>
            <a href="single-slider.html" rel="bookmark">
              <img src="/static/img/uploads/blog-slider-img.png" alt="">
            </a>
          </div>
        </div>
      </div>

      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a rel="bookmark" href="single-slider.html">Post With Slider</a>
          </h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single-slider.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <article class="post hentry">
      <div class="post-media">
        <a href="single-video.html" rel="bookmark">
          <figure class="post-figure">
            <img src="/static/img/uploads/blog-video-img.png" alt="">
          </figure>
          <span class="post-play"><i class="ace-icon ace-icon-play"></i></span>
        </a>
      </div>

      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a rel="bookmark" href="single-video.html">Post With Custom
              Video</a></h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single-video.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <article class="post hentry">
      <div class="post-media">
        <a href="single-audio.html" rel="bookmark">
          <figure class="post-figure">
            <img src="/static/img/uploads/blog-video-img.png" alt="">
          </figure>
          <span class="post-voice"><i class="ace-icon ace-icon-volume-up"></i></span>
        </a>
      </div>

      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a rel="bookmark" href="single-audio.html">Post With Audio
              Player</a></h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single-audio.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <article class="post hentry">
      <div class="post-media">
        <a href="single-vimeo.html" rel="bookmark">
          <figure class="post-figure">
            <img src="/static/img/uploads/blog-video-img.png" alt="">
          </figure>
          <span class="post-play"><i class="ace-icon ace-icon-play"></i></span>
        </a>
      </div>

      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a href="single-vimeo.html" rel="bookmark">Post With Vimeo
              Video</a></h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single-vimeo.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <article class="post hentry">
      <div class="post-media">
        <a href="single-youtube.html" rel="bookmark">
          <figure class="post-figure">
            <img src="/static/img/uploads/blog-video-img.png" alt="">
          </figure>
          <span class="post-play"><i class="ace-icon ace-icon-play"></i></span>
        </a>
      </div>

      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a rel="bookmark" href="single-youtube.html">Post With Youtube
              Video</a></h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single-youtube.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <article class="post hentry">
      <div class="post-media">
        <a href="single-dailymotion.html" rel="bookmark">
          <figure class="post-figure">
            <img src="/static/img/uploads/blog-video-img.png" alt="">
          </figure>
          <span class="post-play"><i class="ace-icon ace-icon-play"></i></span>
        </a>
      </div>

      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a rel="bookmark" href="single-dailymotion.html">Post With
              Dailymotion Video</a></h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single-dailymotion.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <article class="post hentry">
      <div class="post-media">
        <a href="single-soundcloud.html" rel="bookmark">
          <figure class="post-figure">
            <img src="/static/img/uploads/blog-video-img.png" alt="">
          </figure>
          <span class="post-voice"><i class="ace-icon ace-icon-volume-up"></i></span>
        </a>
      </div>

      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a rel="bookmark" href="single-soundcloud.html">Post With
              Soundcloud Video</a></h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single-soundcloud.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <article class="post hentry">
      <div class="padd-box-sm">
        <header class="post-header text-center">
          <h2 class="post-title entry-title text-upper"><a rel="bookmark" href="single.html">Post Without Media</a></h2>

          <div class="post-header-info">
            <span class="posted-on"><span class="screen-reader-text">Posted on </span><a href="http://someurl"
                rel="bookmark">
                <time class="post-date published" datetime="2016-07-04T11:33:08+00:00">4 July 2016</time>
                <time class="post-date updated" datetime="2016-12-08T14:45:55+00:00">8 December 2016</time>
              </a></span>
            &nbsp;<span class="post-author vcard">by <a class="url fn n" href="http://someurl"
                rel="author">Author</a></span>
          </div>
        </header>

        <div class="post-content entry-content editor clearfix clear-mrg">
          <p>Your brand is the core of your marketing, the central theme around your products and services.
            Your brand is not your Logo or your Company Name unless of course you are Microsoft or the
            Yellow Pages online directory.</p>
        </div>

        <footer class="post-footer">
          <div class="post-footer-top brd-btm clearfix">
            <div class="post-footer-info">
              <span class="post-cat-links"><span class="screen-reader-text">Categories</span><a href="http://someurl"
                  rel="category tag">Work</a>&nbsp;,&nbsp;<a href="http://someurl" rel="category tag">Team</a>
              </span><span class="post-line">|</span><a href="" class="post-comments-count">24 comments</a>
            </div>

            <div class="post-more">
              <a class="btn btn-sm btn-primary" href="single.html" rel="bookmark">Read More</a>
            </div>
          </div>
        </footer>
      </div>
    </article><!-- .post -->

    <div class="pagination">
      <a class="next page-numbers" href=""><i class="ace-icon ace-icon-chevron-left"></i></a>
      <span class="page-numbers current">1</span>
      <a class="page-numbers" href="">2</a>
      <a class="page-numbers" href="">3</a>
      <a class="page-numbers" href="">4</a>
      <a class="page-numbers" href="">5</a>
      <a class="next page-numbers" href=""><i class="ace-icon ace-icon-chevron-right"></i></a>
    </div><!-- .pagination -->

    <!-- END: PAGE CONTENT -->

  </div><!-- .ace-paper-cont -->
</template>

<script>
  export default {
    name: 'category',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/category.vue